import {
	GQLOperationalSettingsFragment,
	GQLProductBaseFragment,
	GQLProductFragment,
	GQLProductVariantFragment,
} from '@theprintbar/graphql';
import { VariantAndStatus, getVariantColour } from '.';

export function getVariantsSortedBySizeAndStatus(
	product: Pick<GQLProductFragment, 'variants' | 'colours'>,
	variantExcluded?: (v: GQLProductVariantFragment) => boolean,
): VariantAndStatus[] {
	return (
		product.variants
			?.reduce((acc, variant) => {
				if (!!variantExcluded?.(variant)) return acc;
				const matchingSizeIndex = acc.findIndex(item => variant.size.id === item.variant.size.id);
				const sameday =
					!!variant.warehouseSKU &&
					!!variant.warehouseStock?.length &&
					!!variant.warehouseStock?.every(({ quantity }) => !!quantity);
				const stocked = (!!variant.warehouseSKU && !!variant.supplierStock) || !!sameday;

				if (matchingSizeIndex === -1) {
					acc.push({
						variant,
						stocked,
						sameday,
					});
				} else {
					acc[matchingSizeIndex] = {
						...acc[matchingSizeIndex],
						stocked: acc[matchingSizeIndex].stocked || stocked,
						sameday: acc[matchingSizeIndex].sameday && sameday,
					};
				}

				return acc;
			}, [] as VariantAndStatus[])
			.sort((a, b) => (a.variant.size.order || 0) - (b.variant.size.order || 0)) || []
	);
}
export function getSortedVariantsByColour(product: Pick<GQLProductFragment, 'variants' | 'colours'>, colourCode?: string) {
	return getVariantsSortedBySizeAndStatus(product, variant => !!(colourCode && getVariantColour(product, variant)?.code !== colourCode));
}

export function getSortedSizes(product: Pick<GQLProductFragment, 'variants' | 'colours'>, colourCode?: string) {
	return !!colourCode ? getSortedVariantsByColour(product, colourCode) : getVariantsSortedBySizeAndStatus(product);
}

export const getSortedStockedVariantsByColour = (product: Pick<GQLProductFragment, 'variants' | 'colours'>, colourCode?: string) => {
	return getSortedVariantsByColour(product, colourCode).filter(({ stocked }) => stocked);
};

export const getSizeAdjustmentSteps = (product: GQLProductBaseFragment, operationalSettings: GQLOperationalSettingsFragment) => {
	return {
		xStep: product.useStepOverrides ? product.xStep : operationalSettings.xStep,
		yStep: product.useStepOverrides ? product.yStep : operationalSettings.yStep,
		sizeStep: product.useStepOverrides ? product.sizeStep : operationalSettings.sizeStep,
	};
};
